<template>
  <v-dialog max-width="600" v-model="isActive">


    <v-card title="转工单" rounded="xl" class="gm-dialog-card" v-if="isOrder" :loading="createOrderLoading">
      <v-form :disabled="createOrderLoading">
        <v-container class="px-8">
          <v-text-field v-bind="inputAttrs" v-model="formData.name" label="电站名称" required></v-text-field>
          <v-select v-bind="inputAttrs" v-model="formData.type" label="设备类型" required
            :items="equipmentTypeMap.toOptions()" item-title="label"></v-select>
          <v-text-field v-bind="inputAttrs" v-model="formData.equipmentName" label="能量块名称" required></v-text-field>
          <v-select v-bind="inputAttrs" v-model="formData.moduleType" label="模块类型" required
            :items="modelTypeMap.toOptions()" item-title="label"></v-select>
          <v-select v-bind="inputAttrs" v-model="formData.level" label="故障等级" required
            :items="alarmLevelMap.toOptions()" item-title="label"></v-select>
          <v-text-field v-bind="inputAttrs" v-model="formData.code" label="故障编码" required></v-text-field>
          <v-text-field v-bind="inputAttrs" v-model="formData.description" label="故障描述" required></v-text-field>
          <!-- <v-text-field v-bind="inputAttrs" v-model="formData.details" label="故障详情" required></v-text-field> -->
          <v-textarea color="var(--color-primary)" v-model="formData.details" label="故障详情"></v-textarea>
        </v-container>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text="取消" @click="isOrder = false"></v-btn>
        <v-btn color="var(--color-primary)" text="确定" @click="confirmOrder"></v-btn>
      </v-card-actions>
    </v-card>

    <v-card title="告警信息" rounded="xl" class="alarm-card" :loading="loading" v-else>
      <template #title>
        <div class="d-flex align-center ga-4">
          <div class="rounded-bg">
            <Siren />
          </div>
          <span>告警: 电站离线</span>
          <v-chip class="ml-2" :color="alarmLevelMap.getColor(alarm.level)" variant="outlined">{{
            alarmLevelMap.getText(alarm.level) }}</v-chip>
        </div>
      </template>
      <div class="alarm-station-name">{{ task.name }}</div>
      <v-card-text class="alarm-card-content rounded-lg">
        <DataCardPropsProvide :value-style="{ 'font-size': '16px', 'font-weight': 'bold' }" title-position="left">
          <!-- <DataCard title="电站名称" :value="task.name" /> -->
          <DataCard title="告警类型" :value="modelTypeMap.getText(alarm.moduleType)"
            :class="modelTypeMap.getClass(alarm.moduleType)" />
          <DataCard title="告警等级" :value="alarmLevelMap.getText(alarm.level)"
            :class="alarmLevelMap.getClass(alarm.level)" />
          <DataCard title="告警开始时间" :value="dayjs(alarm.startTime).format('YYYY-MM-DD HH:mm:ss')" />
          <DataCard title="告警结束时间" :value="dayjs(alarm.endTime).format('YYYY-MM-DD HH:mm:ss')" />
          <DataCard title="告警码" :value="alarm.alarmCode" />
          <DataCard title="设备UUID" :value="alarm.uuid" />
          <DataCard title="设备类型" :value="equipmentTypeMap.getText(alarm.type)"
            :class="equipmentTypeMap.getClass(alarm.type)" />
          <DataCard title="告警描述" :value="alarm.description" />
          <DataCard title="触发次数" :value="alarm.triggerCount" :animation="false" unit="次" />
          <DataCard title="恢复次数" :value="alarm.recoveryCount" :animation="false" unit="次" />
          <DataCard title="状态" :value="alarmStatusMap.getText(alarm.state)"
            :class="alarmStatusMap.getClass(alarm.state)" />
          <DataCard title="告警值" :value="alarm.value" />
        </DataCardPropsProvide>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text="忽略" @click="isActive = false"></v-btn>
        <!-- <v-btn color="var(--color-primary)" text="转工单" @click="convertToOrder()"></v-btn> -->
      </v-card-actions>
    </v-card>




  </v-dialog>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, watch } from 'vue'
import { createWorkOrder, queryAlarmDetail } from '@/api/workbench/it'
import DataCardPropsProvide from '@/components/DataCard/PropProvide.vue'
import DataCard from '@/components/DataCard/index.vue'
import { createStatusMap } from '@/utils'
import dayjs from 'dayjs'
import { eui } from 'ems-ui'
import { Siren } from 'lucide-vue-next'

const inputAttrs = {
  color: 'var(--color-primary)',
  density: 'compact',
  variant: 'underlined',
}


// 0=提示,1=告警,2=故障,3=严重故障
const alarmLevelMap = createStatusMap({
  '0': { text: '提示', class: 'text-orange', color: 'orange' },
  '1': { text: '告警', class: 'text-warning', color: 'warning' },
  '2': { text: '故障', class: 'text-error', color: '#FD694B' },
  '3': { text: '严重故障', class: 'text-error', color: 'error' },
})

// 1：未处理 2：自动恢复 3：人工确认
const alarmStatusMap = createStatusMap({
  '1': { text: '未处理', class: 'text-orange' },
  '2': { text: '自动恢复', class: 'text-green' },
  '3': { text: '人工确认', class: 'text-primary' },
  '4': { text: '已转工单', class: 'text-primary' },
  '5': { text: '工单处理完成', class: 'text-primary' },
})

// 00=默认,01=PCS,02=BCS,03=BMS,04=eLink,05=水机,06=消防,07=100C-dcdc,08=100C-MPPT,E1=eBlock,E2=EMS
const equipmentTypeMap = createStatusMap({
  '00': { text: '默认', class: 'text-primary' },
  '01': { text: 'PCS', class: 'text-primary' },
  '02': { text: 'BCS', class: 'text-primary' },
  '03': { text: 'BMS', class: 'text-primary' },
  '04': { text: 'eLink', class: 'text-primary' },
  '05': { text: '水机', class: 'text-primary' },
  '06': { text: '消防', class: 'text-primary' },
  '07': { text: '100C-dcdc', class: 'text-primary' },
  '08': { text: '100C-MPPT', class: 'text-primary' },
  'E1': { text: 'eBlock', class: 'text-primary' },
  'E2': { text: 'EMS', class: 'text-primary' },
})

// 模块类型（默认00，运营类告警：【01需量, 02逆流，03非计划，04 离线，05 电压，06温度，07收益，08效率，09soc】，工商业和eBlock100C预留）
const modelTypeMap = createStatusMap({
  '00': { text: '默认', class: 'text-primary' },
  '01': { text: '需量', class: 'text-primary' },
  '02': { text: '逆流', class: 'text-primary' },
  '03': { text: '非计划', class: 'text-primary' },
  '04': { text: '离线', class: 'text-primary' },
  '05': { text: '电压', class: 'text-primary' },
  '06': { text: '温度', class: 'text-primary' },
  '07': { text: '收益', class: 'text-primary' },
  '08': { text: '效率', class: 'text-primary' },
  '09': { text: 'soc', class: 'text-primary' },
})

const emit = defineEmits(['transferOrder'])

const props = defineProps({
  task: {
    default: () => { },
    type: Object
  }
})

const alarm = ref({})

const isActive = defineModel({
  default: false
})


const loading = ref(false)
const isOrder = ref(false)

watch(() => isActive.value, (newVal) => {
  if (newVal) {
    loading.value = true
    isOrder.value = false
    queryAlarmDetail({
      messageId: props.task.messageId,
      uuid: props.task.uuid
    }).then(res => {
      console.log('open dialog', res)
      alarm.value = res.data || {}
    }).finally(() => {
      loading.value = false
    })
  }
})



const formData = ref({})


function convertToOrder() {
  isOrder.value = true

  formData.value = {
    ...alarm.value,
    name: props.task.name,
    level: alarm.value.level + '',
  }
}



const createOrderLoading = ref(false)
async function confirmOrder() {
  // isActive.value = false

  try {
    createOrderLoading.value = true
    const res = await createWorkOrder({
      "station_id": props.task.stationId,
      "uuid": props.task.uuid,
      "warn_order_number": "",
      "order_type": "",
      "station_name": props.task.name,
      "equip_type": formData.value.type,
      "eblock_name": formData.value.equipmentName,
      "module_type": formData.value.moduleType,
      "fault_level": formData.value.level,
      "fault_code": formData.value.code,
      "fault_desc": formData.value.description,
      "fault_detail": formData.value.detail,
    })
    isActive.value = false
    eui.showToast('转工单成功', 'success')
    emit('transferOrder')
  } catch (error) {
    console.log('create work order error', error)
  } finally {
    createOrderLoading.value = false
  }
}

</script>
<style scoped lang="scss">
.alarm-info-item {
  margin-bottom: 10px;
}

:deep(.data-card__text) {
  color: currentColor;
}

.alarm-card {
  scrollbar-gutter: stable;
  background: linear-gradient(187deg, #FEC6C0 0%, #fff 15%, #fff 100%);
  // padding: 24px;
}

.alarm-card-content {
  padding: 20px;
  background: #F8F8F8;
  margin: 16px;
}


.rounded-bg {
  width: 36px;
  height: 36px;
  background: #FD694B;
  color: #fff;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.alarm-station-name {
  margin-left: 16px;
  margin-top: 16px;
  border-left: 4px solid #FD694B;
  padding-left: 8px;
}
</style>
